var map = {
	"./98acres.jpg": 5034,
	"./Galle-Dutch-Fort.jpg": 9277,
	"./Galle_Maritime_Museum.jpg": 5015,
	"./KHotel1.jpg": 4403,
	"./KHotel2.jpg": 6777,
	"./KHotel3.jpg": 6194,
	"./annasa.jpg": 9196,
	"./anuradhapura.jpg": 2702,
	"./aru1.jpg": 1987,
	"./aru2.jpg": 442,
	"./aru3.jpg": 4092,
	"./aruHome.jpg": 9631,
	"./aruHotel1.jpg": 381,
	"./aruHotel2.jpg": 7028,
	"./aruHotel3.jpg": 4562,
	"./baymarriott.jpg": 1357,
	"./botanicalGarden.jpg": 8006,
	"./capeweli.jpg": 4500,
	"./cinnamonlakeside.jpg": 4240,
	"./colomboHome.jpg": 1072,
	"./colombomain.jpg": 5237,
	"./dondra.jpg": 4547,
	"./dreamcliffjpg.jpg": 6562,
	"./ellarock.jpg": 6401,
	"./ellawallpaper.jpg": 7558,
	"./gallefacegreen.jpg": 688,
	"./heritage.jpg": 2856,
	"./hilton.jpg": 4019,
	"./jaffna1.jpg": 975,
	"./jaffna2.jpg": 583,
	"./jaffna3.jpg": 3933,
	"./jaffnaHome.jpg": 6172,
	"./jaffnaHotel1.jpg": 7886,
	"./jaffnaHotel2.jpg": 9181,
	"./jaffnaHotel3.jpg": 3427,
	"./kandyImg.jpg": 9514,
	"./kandyjungle.jpg": 2550,
	"./kingsbury.jpg": 4594,
	"./leGrand.jpg": 2200,
	"./lighthouse.jpg": 4701,
	"./lotus-tower.jpg": 9324,
	"./matara.jpg": 6794,
	"./museum.jpg": 8573,
	"./newgalleimge1.jpg": 778,
	"./nine-arch-2-5.jpg": 297,
	"./nuwara1.jpg": 4516,
	"./nuwara2.jpg": 3456,
	"./nuwara3.jpg": 4551,
	"./nuwaraHotel1.jpg": 8050,
	"./nuwaraHotel2.jpg": 8149,
	"./nuwaraHotel3.jpg": 7647,
	"./nuwaraMain.jpeg": 7204,
	"./paravi.jpg": 1710,
	"./raddisson.jpg": 1214,
	"./rajarata.jpg": 5967,
	"./ravana-falls-6.jpg": 9747,
	"./ruwanwelisaya.jpg": 5972,
	"./smb.jpg": 2037,
	"./templeOfTheTooth.jpg": 8690,
	"./the-shrine-of-our-lady.jpg": 8069,
	"./thuparamaya.jpg": 874,
	"./tlfh.jpg": 3432,
	"./trincomalee1.jpg": 4804,
	"./trincomalee_hotel1.jpg": 5764,
	"./trincomalee_hotel2.jpg": 5437,
	"./trincomalee_hotel3.jpg": 782,
	"./trincomalee_place1.jpg": 3195,
	"./trincomalee_place2.jpg": 1955,
	"./trincomalee_place3.jpg": 8294,
	"./turtle-hatchery-hikkaduwa.jpg": 9187,
	"./w15.jpg": 4251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 721;